module.exports = __webpack_public_path__ + "static/media/404@3x.d512b5ae.png";